module.exports = __webpack_public_path__ + "img/趋势分析，爆款直达ico.763cda71.png";